import { PersonPosition } from "../../../company-structure/person-position";
import { PersonDepartment } from "../../../company-structure/person-department";
import { PersonPositionAndOrganizationFragment } from "gql/graphql";
import { Hidable, valueOrNull } from "@/shared/value";

export function PersonPositionAndOrganizationColumn({
  data,
}: {
  data?: Hidable<PersonPositionAndOrganizationFragment>;
}) {
  const person = valueOrNull(data);

  return (
    <div className="grid">
      <PersonDepartment data={person?.organization} />
      <PersonPosition data={person?.position} />
    </div>
  );
}
